import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, Image } from '../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class FullTeaserSplitConverter extends CmsConverterService<FullTeaserSplitData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData.st_image_alt_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      backgroundColor: formData.st_backgroundcolor?.value?.identifier ?? '',
      deactivateBlendMode: formData?.st_deactivate_blend_mode?.value ?? false,
      image: CmsConverterService.mapImage(formData.st_image, lazyLoad, altText, title),
      imageInRightBox: formData.st_image_in_right_box?.value ?? false,
      boxes: formData.st_boxes ?? defaultFSCatalog,
    }
  }
}

export const FULL_TEASER_SPLIT_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, FullTeaserSplitData>>(
  'FullTeaserSplitConverter')

export interface FullTeaserSplitData extends ConvertedComponentData {
  image: Image;
  backgroundColor: string;
  deactivateBlendMode: boolean;
  imageInRightBox: boolean;
  boxes: FsCatalog;
}
